import {Injectable} from "@angular/core";
import {UrlService} from "../../common/url.service";

import {UsanaObject} from "../../usana-object";
import { HttpClient } from "@angular/common/http";
import {LoggerService} from "../../common/logger.service";

import {ErrorUtil} from "../../util/error-util";
import {IRestResponse} from "../../common/rest-response.model";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {EnrollCustomer} from "../enroll-models";

@Injectable({
    providedIn: 'root'
})
export class EnrollPcService extends UsanaObject {

    constructor(
        private http: HttpClient,
        private urlService: UrlService,
        loggerService: LoggerService
    ) {
        super(loggerService);
    }

    saveCustomer(customer: EnrollCustomer): Promise<any> {
        return this.http.post(this.urlService.buildCartUrl("/customer/"), customer).toPromise().then((response: IRestResponse) => {
            if (!!response && response.success) {
                return Promise.resolve(response.message);
            } else {
                return ErrorUtil.handleError(response);
            }
        }, (error: any) => ErrorUtil.handleError(error));
    }

    hasTaxId(country: string, customerType: string): Promise<any> {
        const params: {[param: string]: string} = {
            country: country,
            customerType: customerType};
        return this.http.get(this.urlService.buildCartUrl("/customer/taxId"), {params}).toPromise().then((response: IRestResponse) => {
            if (!!response && response.success) {
                return Promise.resolve(response.message);
            } else {
                return ErrorUtil.handleError(response);
            }
        }, (error: any) => ErrorUtil.handleError(error));
    }

    saveCbecCustomer(customer: EnrollCustomer): Observable<any> {
        return this.http.post(this.urlService.buildCartUrl("/customer/cbec/enroll"),customer).pipe(
            map((response: any)=> response),
            catchError((error: any) => throwError(error))
        );
    }
}
